var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C6.95646 0 3.66664 3.28982 3.66664 7.33335C3.66664 8.54722 3.97013 9.75077 4.54707 10.8183L10.599 21.7637C10.6795 21.9096 10.8331 22 11 22C11.1669 22 11.3205 21.9096 11.401 21.7637L17.4551 10.8147C18.0298 9.75077 18.3333 8.54717 18.3333 7.3333C18.3333 3.28982 15.0435 0 11 0ZM11 11C8.97822 11 7.33334 9.35511 7.33334 7.33335C7.33334 5.31158 8.97822 3.6667 11 3.6667C13.0218 3.6667 14.6666 5.31158 14.6666 7.33335C14.6666 9.35511 13.0218 11 11 11Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e0eb5ecf3682856247d3f74fbba514df.svg";
export { ForwardRef as ReactComponent };